/* eslint-disable import/prefer-default-export */
export const addToDataLayer = (data) => {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-undef
  dataLayer.push({
    'email': document.getElementById('user_email').value,
    'nombre': document.getElementById('user_first_name').value,
    'apellido': document.getElementById('user_last_name').value,
    'telefono': document.getElementById('user_retailer_phone').value,
    'empresa': document.getElementById('user_retailer_name').value,
    'retailer_id': document.getElementById('user_retailer_id').value,
    'retailer_slug': document.getElementById('user_retailer_slug').value,
    ...data
  });
};
